import axios from './axios.js'


//获取所有产品
export const getProductListApi = function () {
    return axios({
        method: 'get',
        url: 'api/prod/list',
    })
}

export const getProductDetailApi = function (args) {
    return axios({
        method: 'get',
        url: `api/prod/detail/${args.pid}`,
    })
}

//获取banner
export const getBannerListApi = function () {
    return axios({
        method: 'get',
        url: 'api/banner/list',
    })
}

//评论相关
export const getEvaluaterListApi = function (args) {
    return axios({
        method: 'get',
        url: 'api/evaluate/get',
        params:{
            pageSize: args.pageSize,
            currentPage: args.currentPage,
            prodId: args.prodId
        }
    })
}
export const getEvaluaterProdtypeListApi = function () {
    return axios({
        method: 'get',
        url: 'api/evaluate/prodtype/list',
    })
}

// =====权益转移相关=====
// 检测登录态
export const checkLoginApi = function(){
    return axios({
        method: 'get',
        url: '/api/login/check',
    })
}
// 退出登录态
export const checkLogoutApi = function(){
    return axios({
        method: 'get',
        url: '/api/login/logout',
    })
}

// 获取验证码
export const getCodeApi = function(args){
    return axios({
        method: 'POST',
        url: '/api/login/csite/phone/code',
        data: args,
    })
}

// 验证码登录
export const loginByCodeApi = function(args){
    return axios({
        method: 'POST',
        url: '/api/login/csite/phone',
        data: args,
    })
}

// 账号密码登录
export const loginByAccountApi = function(args){
    return axios({
        method: 'POST',
        url: '/api/login/csite/account',
        data: args,
    })
}

// 微信登录
export const wechatLoginApi = function(args){
    return axios({
        method: 'POST',
        url: (process.env.NODE_ENV == 'production' ?'' :'https://pc.mimoprint.com') + '/api/login/weChat',
        data: args,
    })
}


// 绑定微盟
export const bindWMApi = function(args){
    return axios({
        method: 'POST',
        url: '/api/login/mmcsite/bind',
        data: args,
    })
}

// 获取权益信息
export const getRightsApi = function(){
    return axios({
        method: 'get',
        url: '/api/migrate/rights/list',
    })
}


// 迁移权益
export const startTransferApi = function(args){
    return axios({
        method: 'POST',
        url: '/api/migrate/mmcsite/start',
        data: args,
    })
}


//检查迁移状态
export const checkTransferStateApi = function(){
    return axios({
        method: 'get',
        url: '/api/migrate/check',
    })
}